<template>
  <div class="layout-inner explore_entity_result job_applications">
    <navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">
        <template v-if="!isFilterPanelOpen && !isSortPanelOpen">
          <div class="sub_hd_bar">
            <div class="sub_hd_ic">
              <span @click="openFilterPanel" class="filter">
                <span class="ic ic-filter" :class="statusFilterSelected.length > 0 ? 'active' : ''"></span>
                <span class="count" v-if="statusFilterSelected.length > 0">
                  <span>{{ statusFilterSelected.length }}</span>
                </span>
              </span>
            </div>
            <div class="srh_bx">
              <input type="text" class="search-input" :placeholder="$t('typeToNarrowResults')" v-on:keyup.enter="searchButtonClicked" v-model.trim="searchTerms"/>
              <span @click="searchButtonClicked" class="search-icon">
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
            </div>
            <div class="sort_by" @click="openSortPanel">
              <span class="sort_by_link">{{ $t('sort') }}</span>
            </div>
            <div class="list_info">
              {{ $t('applicationCount', { total: filteredApplications.length }) }}
            </div>
          </div>
          <div class="job-filter-chips" v-if="statusFilterSelected.length > 0">
            <div
              class="job-filter-chip"
              v-for="(statusValue, index) in statusFilterSelected"
              :key="'status-filter-' + statusValue">
              <span class="job-filter-chip-label application-status-tag">{{ statusValue }}</span>
              <button type="button" class="job-filter-chip-remove" :aria-label="$t('delete')" @click.stop="removeStatusFilter(index)">
                <span class="icon-bin" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </template>

        <div class="container-fluid flex-grow-1 pg_content_container" style="padding-top: 0px;">
          <template v-if="isFilterPanelOpen">
            <div class="container filter_selection_flds_container">
              <div class="filter_fld_head">
                <div class="hd_txt">{{ $t('selectApplicationStatus') }}</div>
              </div>
              <div class="filter_fld_container">
                <label v-for="statusValue in statusArray" :key="'filter-' + statusValue">
                  <input type="checkbox" :value="statusValue" v-model="statusFilterDraft">
                  <span class="input_txt">{{ statusValue }}</span>
                </label>
              </div>
              <div class="btn_container">
                <b-btn @click="filtersOkClicked">{{ $t('ok') }}</b-btn>
              </div>
            </div>
          </template>

          <template v-else-if="isSortPanelOpen">
            <div class="container filter_selection_flds_container">
              <div class="filter_fld_head">
                <div class="hd_txt">{{ $t('sortBy') }}</div>
              </div>
              <div class="mt-2 ml-4">
                <div class="field-row mb-3" v-for="sort in sorts" :key="sort.name">
                  <div class="form-check">
                    <input type="radio" class="form-check-input" :id="'application-sort-' + sort.name" v-model="selectedSortName" :value="sort.name">
                    <label class="form-check-label" :for="'application-sort-' + sort.name">{{ sort.labelKey ? $t(sort.labelKey) : sort.name }}</label>
                  </div>
                </div>
                <div class="btn_container">
                  <b-btn @click="sortOkClicked">{{ $t('ok') }}</b-btn>
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <template v-if="isLoading">
              <div class="w-100 h-100 d-flex justify-content-center align-items-center">
                <spinner size="large"></spinner>
              </div>
            </template>
            <template v-else-if="pagedApplications.length > 0">
              <div
                class="application-row"
                v-for="(application, index) in pagedApplications"
                :key="applicationKey(application, index)">
                <div class="application-row-main" @click="goToJob(application)">
                  <div class="application-job">{{ application.jobTitle }}</div>
                  <div class="application-employer">
                    <div
                      class="employer-avatar"
                      :class="{ 'has-logo': employerLogo(application) }"
                      :style="employerLogo(application) ? null : { background: avatarColor(index) }">
                      <img v-if="employerLogo(application)" :src="employerLogo(application)" :alt="application.employerTitle || ''">
                      <span v-else>{{ employerInitials(application.employerTitle) }}</span>
                    </div>
                    <div class="employer-name">{{ application.employerTitle }}</div>
                  </div>
                  <div class="status-boxes">
                    <div
                      class="status-box"
                      v-for="stage in statusStages"
                      :key="stage.key"
                      :class="{
                        'is-complete': isStageComplete(application, stage),
                        'is-rejected': isStageRejected(application, stage)
                      }">
                    </div>
                  </div>
                  <button
                    type="button"
                    class="expand-btn"
                    @click.stop="toggleExpand(application, index)">
                    <span class="fa" :class="isExpanded(application, index) ? 'fa-angle-up' : 'fa-angle-down'"></span>
                  </button>
                </div>
                <div class="application-row-details" v-if="isExpanded(application, index)">
                  <template v-for="(stage, stageIndex) in statusStages">
                    <div
                      class="expanded-status-box"
                      :key="'detail-' + stage.key"
                      :class="{
                        'is-complete': isStageComplete(application, stage),
                        'is-rejected': isStageRejected(application, stage),
                        'has-offer-actions': canRespondToOffer(application, stage)
                      }">
                      <template v-if="canRespondToOffer(application, stage)">
                        <div class="offer-actions">
                          <button type="button" class="offer-btn accept" @click.stop="confirmOfferResponse(application, 'accept')">{{ $t('accept') }}</button>
                          <button type="button" class="offer-btn decline" @click.stop="confirmOfferResponse(application, 'decline')">{{ $t('decline') }}</button>
                        </div>
                      </template>
                      <template v-else>
                        <span class="expanded-status-label">{{ stageDisplayLabel(application, stage) }}</span>
                        <span class="expanded-status-date">{{ stageDateLabel(application, stage) }}</span>
                      </template>
                    </div>
                    <span
                      class="status-box-separator"
                      v-if="stageIndex < statusStages.length - 1"
                      :key="'sep-' + stage.key"
                      aria-hidden="true">&gt;</span>
                  </template>
                </div>
              </div>
              <div class="job-pagination">
                <button type="button" class="btn" :disabled="firstPage" @click="prev">{{ $t('previousPage') }}</button>
                <span class="current-page">{{ page + 1 }}</span>
                <button type="button" class="btn" :disabled="lastPage" @click="next">{{ $t('nextPage') }}</button>
              </div>
            </template>
            <template v-else>
              <div class="col-12 no_result mt-5">{{ $t('noResult') }}</div>
            </template>
          </template>
        </div>
      </div>
    </div>

    <b-modal ref="offerConfirmModal" no-close-on-backdrop no-close-on-esc centered>
      <div slot="modal-header" class="row header-section w-100">
        <div class="col-10 hd_txt">{{ $t('pleaseConfirm') }}</div>
        <div class="col-2 btn_container">
          <button class="btn_close" :aria-label="$t('close')" @click="cancelOfferResponse">
            <span class="ic-close"></span>
          </button>
        </div>
      </div>
      <div>{{ offerConfirmMessage }}</div>
      <div slot="modal-footer" class="w-100">
        <b-button @click="confirmOfferResponseYes" class="btn float-right mr-2">{{ $t('yes') }}</b-button>
        <b-button @click="cancelOfferResponse" class="btn float-right mr-2">{{ $t('no') }}</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import jobApplicationStatus from '../jobApplicationStatus'

export default {
  name: 'myJobApplications',
  mixins: [jobApplicationStatus],
  components: {
    Navbar
  },
  data () {
    return {
      isLoading: true,
      isFilterPanelOpen: false,
      isSortPanelOpen: false,
      jobApplications: [],
      pageSize: 20,
      firstPage: true,
      lastPage: true,
      page: 0,
      searchTerms: '',
      appliedSearch: '',
      collapsedApplicationKeys: {},
      statusFilterDraft: [],
      statusFilterSelected: [],
      selectedSortName: 'Job',
      sorts: [
        { name: 'Job', labelKey: 'job' },
        { name: 'Employer', labelKey: 'employerFilter' },
        { name: 'Applied On', labelKey: 'appliedOn' },
        { name: 'Status', labelKey: 'status' }
      ],
      statusArray: ['Applied', 'Reviewed', 'Interview Scheduled', 'Interview Done', 'Job Offered', 'Job Accepted'],
      avatarColors: ['#e08a4a', '#3d5a99', '#9b8ac4', '#4a7c8c'],
      offerResponseSaving: false,
      pendingOfferApplication: null,
      pendingOfferAction: ''
    }
  },
  mounted () {
    this.loadJobApplications()
  },
  methods: {
    ...mapActions([
      'getJobApplications',
      'updateJobApplicationUserStatus'
    ]),
    openFilterPanel () {
      this.statusFilterDraft = this.statusFilterSelected.slice()
      this.isFilterPanelOpen = true
    },
    openSortPanel () {
      this.isSortPanelOpen = true
    },
    loadJobApplications () {
      this.isLoading = true
      this.jobApplications = []
      this.getJobApplications().then(res => {
        this.jobApplications = this.normalizeApplications(res)
        this.page = 0
        this.updatePaging()
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    normalizeApplications (res) {
      if (!res) {
        return []
      }
      if (res.content && res.content.length >= 0) {
        return res.content
      }
      if (res.length >= 0) {
        return res
      }
      if (res.status || res.jobId) {
        return [res]
      }
      return []
    },
    updatePaging () {
      let totalPages = Math.ceil(this.filteredApplications.length / this.pageSize)
      if (totalPages < 1) {
        totalPages = 1
      }
      if (this.page > totalPages - 1) {
        this.page = totalPages - 1
      }
      this.firstPage = this.page <= 0
      this.lastPage = this.page >= totalPages - 1
    },
    searchButtonClicked () {
      this.appliedSearch = this.searchTerms
      this.resetPage()
    },
    filtersOkClicked () {
      this.statusFilterSelected = this.statusFilterDraft.slice()
      this.isFilterPanelOpen = false
      this.resetPage()
    },
    removeStatusFilter (index) {
      this.statusFilterSelected.splice(index, 1)
      this.statusFilterDraft = this.statusFilterSelected.slice()
      this.resetPage()
    },
    sortOkClicked () {
      this.isSortPanelOpen = false
      this.resetPage()
    },
    sortApplications (list) {
      let sorted = list.slice()
      let name = this.selectedSortName
      sorted.sort((a, b) => {
        if (name === 'Applied On') {
          return (this.applicationDate(b) || 0) - (this.applicationDate(a) || 0)
        }
        if (name === 'Status') {
          return (a.status || '').localeCompare(b.status || '')
        }
        if (name === 'Employer') {
          return (a.employerTitle || '').localeCompare(b.employerTitle || '')
        }
        return (a.jobTitle || '').localeCompare(b.jobTitle || '')
      })
      return sorted
    },
    resetPage () {
      this.page = 0
      this.updatePaging()
    },
    prev () {
      if (this.firstPage) {
        return
      }
      this.page -= 1
      this.updatePaging()
    },
    next () {
      if (this.lastPage) {
        return
      }
      this.page += 1
      this.updatePaging()
    },
    applicationKey (application, index) {
      if (!application) {
        return index
      }
      return application.uuid || application.applicationUuid || application.applicationId || application.jobId || index
    },
    toggleExpand (application, index) {
      let key = this.applicationKey(application, index)
      if (this.collapsedApplicationKeys[key]) {
        this.$delete(this.collapsedApplicationKeys, key)
        return
      }
      this.$set(this.collapsedApplicationKeys, key, true)
    },
    isExpanded (application, index) {
      return !this.collapsedApplicationKeys[this.applicationKey(application, index)]
    },
    employerInitials (title) {
      if (!title) {
        return ''
      }
      let first = title.trim().split(/\s+/)[0]
      if (first.length <= 4) {
        return first.toUpperCase()
      }
      return first.substring(0, 3).toUpperCase()
    },
    employerLogo (application) {
      if (!application) {
        return ''
      }
      return application.employerLogo || ''
    },
    avatarColor (index) {
      return this.avatarColors[index % this.avatarColors.length]
    },
    goToJob (application) {
      if (application && application.jobId) {
        this.$router.push({ name: 'jobHome', params: { uuid: application.jobId } })
      }
    },
    confirmOfferResponse (application, action) {
      this.pendingOfferApplication = application
      this.pendingOfferAction = action
      this.$refs.offerConfirmModal.show()
    },
    cancelOfferResponse () {
      this.pendingOfferApplication = null
      this.pendingOfferAction = ''
      this.$refs.offerConfirmModal.hide()
    },
    confirmOfferResponseYes () {
      let application = this.pendingOfferApplication
      let action = this.pendingOfferAction
      this.$refs.offerConfirmModal.hide()
      this.pendingOfferApplication = null
      this.pendingOfferAction = ''
      this.respondToOffer(application, action)
    },
    respondToOffer (application, action) {
      if (!application || this.offerResponseSaving) {
        return
      }
      let applicationId = application.uuid
      if (!applicationId) {
        return
      }
      let status = action === 'accept' ? 'Accepted' : 'Declined'
      this.offerResponseSaving = true
      this.updateJobApplicationUserStatus({ applicationId: applicationId, status: status }).then((response) => {
        this.offerResponseSaving = false
        let title = application.jobTitle || ''
        if (response) {
          this.applyOfferResponse(application, response)
          this.notifySuccess(this.$t('successfullyUpdatedApplication') + ' \'' + title + '\'')
        } else {
          this.notifyFailure(this.$t('unableToUpdateApplication') + ' \'' + title + '\'')
        }
      }).catch(() => {
        this.offerResponseSaving = false
        this.notifyFailure(this.$t('unableToUpdateApplication') + ' \'' + (application.jobTitle || '') + '\'')
      })
    },
    applyOfferResponse (application, response) {
      let updated = Object.assign({}, application)
      if (response && typeof response === 'object' && !Array.isArray(response)) {
        if (response.data && (response.data.status || response.data.uuid)) {
          updated = Object.assign(updated, response.data)
        } else {
          updated = Object.assign(updated, response)
        }
      }
      let key = application.uuid
      this.jobApplications = this.jobApplications.map((item) => {
        if (item.uuid === key) {
          return Object.assign({}, item, updated)
        }
        return item
      })
    },
    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    }
  },
  computed: {
    offerConfirmMessage () {
      if (this.pendingOfferAction === 'decline') {
        return this.$t('declineOfferConfirm')
      }
      return this.$t('acceptOfferConfirm')
    },
    filteredApplications () {
      let list = this.jobApplications || []
      if (this.appliedSearch) {
        let term = this.appliedSearch.toLowerCase()
        list = list.filter((application) => {
          let title = application.jobTitle || ''
          let employer = application.employerTitle || ''
          return title.toLowerCase().indexOf(term) !== -1 || employer.toLowerCase().indexOf(term) !== -1
        })
      }
      if (this.statusFilterSelected && this.statusFilterSelected.length > 0) {
        list = list.filter((application) => {
          return this.statusFilterSelected.indexOf(application.status) !== -1
        })
      }
      return this.sortApplications(list)
    },
    pagedApplications () {
      let start = this.page * this.pageSize
      return this.filteredApplications.slice(start, start + this.pageSize)
    }
  }
}
</script>

<style scoped>
  .job-filter-chips {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    padding: 8px 16px;
    box-sizing: border-box;
    background: #fff;
  }
  .job-filter-chip {
    display: inline-flex;
    flex-direction: row;
    align-items: stretch;
    flex: 0 1 auto;
    max-width: 100%;
    border: 1px solid #b3b3b3;
    background: #fff;
    overflow: hidden;
  }
  .job-filter-chip-label {
    display: block;
    padding: 6px 8px;
    line-height: 1.3;
    word-break: break-word;
  }
  .job-filter-chip-label.application-status-tag {
    background-color: #7ad8f0;
  }
  .job-filter-chip-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 32px;
    width: 32px;
    margin: 0;
    padding: 0;
    border: 0;
    border-left: 1px solid #dcdcdc;
    background: #fff;
    color: #4a6d8c;
    cursor: pointer;
  }
  .job-filter-chip-remove .icon-bin {
    font-size: 16px;
    line-height: 1;
    color: #4a6d8c;
  }
  .job-filter-chip-remove .icon-bin::before {
    font-family: 'ic_main' !important;
    content: "\eb70" !important;
  }
  .application-row {
    background: #fff;
    border-bottom: 1px solid #e6e6e6;
    padding: 12px 16px;
  }
  .application-job {
    font-weight: 500;
    margin-bottom: 8px;
    cursor: pointer;
  }
  .application-row-main {
    position: relative;
    padding-right: 28px;
    cursor: pointer;
  }
  .application-employer {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .employer-avatar {
    width: 72px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    color: #000;
    font-weight: 600;
    overflow: hidden;
    flex-shrink: 0;
  }
  .employer-avatar.has-logo {
    background: transparent;
  }
  .employer-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .expand-btn {
    position: absolute;
    right: 0;
    top: 0;
    border: none;
    background: transparent;
    font-size: 18px;
  }
  .status-boxes {
    display: flex;
    gap: 4px;
  }
  .status-box {
    width: 16px;
    height: 8px;
    border-radius: 4px;
    background: #ddd;
  }
  .status-box.is-complete {
    background: #67a879;
  }
  .status-box.is-rejected {
    background: #d9534f;
  }
  .application-row-details {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-top: 12px;
  }
  .status-box-separator {
    display: inline-flex;
    align-items: center;
    line-height: 1;
    color: #6b6b6b;
  }
  .expanded-status-box {
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    padding: 8px;
    min-width: 90px;
    background: #f7f7f7;
  }
  .expanded-status-box.is-complete {
    background: #e6f4ea;
    border-color: #67a879;
  }
  .expanded-status-box.is-rejected {
    background: #fdecea;
    border-color: #d9534f;
  }
  .expanded-status-label,
  .expanded-status-date {
    display: block;
    font-size: 12px;
  }
  .expanded-status-box.has-offer-actions {
    padding: 6px;
    min-width: 90px;
    max-width: 110px;
  }
  .offer-actions {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }
  .offer-btn {
    border: none;
    border-radius: 6px;
    padding: 4px 6px;
    font-size: 10px;
    font-weight: 600;
    line-height: 1.2;
    cursor: pointer;
    width: 100%;
    white-space: nowrap;
    color: #fff;
  }
  .offer-btn.accept {
    background: #4caf50;
    color: #fff;
  }
  .offer-btn.decline {
    background: #e53935;
    color: #fff;
  }
  .job-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    gap: 16px;
  }
  .job-pagination .btn {
    color: #fff;
  }
  .job-pagination .btn:disabled {
    color: #fff;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/app/job/components/MyJobApplications.vue